import { useEffect, useState } from "react";
import { PageHero } from "./MarketingLayout";
import { endpoints } from "@/lib/api";

export default function Judges() {
  const [judges, setJudges] = useState([]);
  useEffect(() => { endpoints.judges().then(setJudges).catch(() => {}); }, []);
  return (
    <div>
      <PageHero eyebrow="The scoring crew" title="Judges"
        subtitle="An expert panel scoring every build on design, engineering, finish and pure wow factor." />
      <section className="max-w-7xl mx-auto px-6 pb-24 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {judges.map((j) => (
          <div key={j.id} className="border border-white/10 bg-[#121212] p-8 card-hover" data-testid={`judge-${j.id}`}>
            <div className="w-20 h-20 pas-gradient grid place-items-center font-display text-4xl text-black mb-5">
              {j.name.split(" ").map((n) => n[0]).join("")}
            </div>
            <div className="font-heading text-2xl text-white uppercase">{j.name}</div>
            <div className="text-[#ff7a1a] font-heading uppercase text-sm mb-1">{j.role}</div>
            <div className="text-[#b026ff] font-heading uppercase text-xs mb-3">{j.specialty}</div>
            <p className="text-[#8a8d91] font-body">{j.bio}</p>
          </div>
        ))}
      </section>
    </div>
  );
}
